export default {
  border: true,
  rounded: '@theme:card.rounded',
  height: '100',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'between',
  fontSize: '3',
  fontWeight: 'bold',
  textColor: 'white',
  cursor: 'pointer',
  style: { backgroundColor: 'rgba(0, 0, 0, 0.15)' },
  fareItemBackgroundImage: {
    rounded: '@theme:card.rounded',
    imageHeight: '320px',
  },
  fareBodyItem: {
    padding: '2',
  },
  fareItemOriginDestination: {
    showOriginAirportCode: true,
    showDestinationAirportCode: true,
    showOriginLabel: true,
    showDestinationLabel: true,
    showSeparator: false,
    showLineSeparator: true,
    fontSize: '3',
    textTransform: 'uppercase',
    destinationStyles: {
      fontSize: '5',
    },
    originLabelStyles: {
      paddingRight: '1',
      fontWeight: 'light',
    },
    destinationLabelStyles: {
      paddingRight: '1',
      fontWeight: 'light',
    },
  },
  showPrice: false,
  showMiles: true,
  fareItemMiles: {
    milesPromoLabelKey: 'fare_promo_label-promo-short',
    milesSymbol: 'miles',
    paddingTop: '3',
    paddingBottom: '1',
    textAlign: 'left',
    style: { lineHeight: '1' },
    milesPromoStyles: {
      display: 'block',
      fontWeight: 'light',
      textTransform: 'uppercase',
      marginBottom: '2px',
    },
    amountStyles: {
      display: 'inline-block',
      fontSize: '5',
    },
    taxAmountStyles: {
      display: 'inline-block',
      paddingLeft: '1',
    },
    milesSymbolStyles: {
      paddingLeft: '1',
    },
    taxAmountSymbolStyles: {
      paddingRight: '1',
    },
  },
  fareItemLastSeen: {
    dateStyles: {
      fontWeight: 'light',
    },
  },
  fareItemDepartureInfo: {
    showDepartureText: true,
    showDepartureDate: true,
    departureText: 'cmp-label--departure-date-colon',
    fontWeight: 'light',
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  showReturnInfo: true,
  fareItemReturnInfo: {
    showReturnText: true,
    showReturnDate: true,
    returnText: 'cmp-label--return-date-colon',
    fontWeight: 'light',
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
};
